export default __webpack_public_path__ + "static/svg-sprite-4c24a0d0cede87c85bae9173ee95b746.svg";